module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#news",
      toString: function () {
        return this.url;
      }
    }